export const colors = {
    ICON_BACKGROUND_PURPLE: '#c4b5c9',
    ICON_PURPLE: '#451e53',
    ICON_BACKGROUND_PINK: '#f1b8b8',
    ICON_PINK: '#e57273',
}